import type { OwnerDetails } from "~/v2/api/rest/account";
import type { CountryInfos } from "~/v2/api/rest/onboarding";

const INCOME_THRESHOLD = 20_000;
const NET_WORTH_THRESHOLD = 20_000;

export function isFpslEligible(
  details: OwnerDetails,
  countryInfos: CountryInfos,
): boolean {
  const countryInfo = countryInfos[details.country_of_tax_residence ?? ""];
  if (!countryInfo?.is_fpsl_allowed) {
    return false;
  }

  const incomeEligible = (details.annual_income_min ?? 0) >= INCOME_THRESHOLD;
  const netWorthEligible =
    (details.liquid_net_worth_min ?? 0) >= NET_WORTH_THRESHOLD;
  const experienceEligible =
    !!details.investment_experience_with_stocks &&
    details.investment_experience_with_stocks !== "NONE";

  return incomeEligible || netWorthEligible || experienceEligible;
}
